import { Routes, Route, useLocation } from 'react-router-dom'
import { AdminProvider } from './components/context/AdminContext'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Packages from './pages/Packages'
import Destination from './pages/Destination'
import Booking from './pages/Booking'
import Testimonial from './pages/Testimonial'
import Error from './pages/Error'
import Contact from './pages/Contact'
import AdminPanel from './components/admin-panel-pages/AdminPanel'
import { UserProvider } from './components/context/UserContext'
import UserDashboard from './components/users-pages/UserDashboard'
import UserProfile from './components/users-pages/UserProfile'

// Admin routes-এ Header/Footer show করবে না
const AppLayout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return <div>{children}</div>;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default function App() {
  return (
    <UserProvider>
      <AdminProvider>
        <AppLayout>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/services' element={<Services />} />
            <Route path='/packages' element={<Packages />} />
            <Route path='/destination' element={<Destination />} />
            <Route path='/booking' element={<Booking />} />
            <Route path='/testimonial' element={<Testimonial />} />
            <Route path='/error' element={<Error />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/admin' element={<AdminPanel />} />
            <Route path="/user-dashboard" element={<UserDashboard />} />
            <Route path="/user-profile" element={<UserProfile />} />

            {/* Catch all route - 404 */}
            <Route path='*' element={<Error />} />
          </Routes>
        </AppLayout>
      </AdminProvider>
    </UserProvider>
  )
}